import React from "react"
import UserIcon from "../assets/Images/icons/userImg.svg"
const CreditScoreChart = ({
  value = 0,
  max = 900,
  label = "Excellent",
  progressStroke = "#00C08B",
  className = "",
}) => {
  const radius = 44 
  const circumference = 2 * Math.PI * radius
  const progressPercent = value > max ? 100 : value < 0 ? 0 : (value / max) * 100
  const arcLength = circumference * 0.75
  const gapLength = circumference * 0.25
  const progress = (arcLength * progressPercent) / 100

  return (
    <div className={`w-full max-w-xs aspect-square ${className}`}>
      <div className="relative w-full h-full">
        <svg
          className="w-full h-full "
          viewBox="0 0 110 110"
          preserveAspectRatio="xMidYMid meet"
        >
          {/* Background track */}
          <path
            d="M 55,55 m 0,-44 a 44,44 0 1 1 0,88 a 44,44 0 1 1 0,-88"
            fill="none"
            className="stroke-[#E9EDF0]"
            strokeWidth="5"
            strokeLinecap="round"
            stroke-dasharray={`${arcLength} ${gapLength}`}
            transform="rotate(225 55 55)" 
          />

          {/* Progress arc */}
          <path
            d="M 55,55 m 0,-44 a 44,44 0 1 1 0,88 a 44,44 0 1 1 0,-88"
            fill="none"
            className={`stroke-emerald-500 transition-all duration-500 ease-in-out`}
            strokeWidth="12" 
            strokeLinecap="round"
            stroke-dasharray={`${progress} ${circumference}`}
            transform="rotate(225 55 55)"
            style={{ stroke:progressStroke }}
          />
        </svg>

        {/* Center content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="flex items-center gap-1 flex-col">
            <img src={UserIcon} alt="user" className="w-[36px] h-[36px]" />
            <span className="text-[length:min(2rem,8vw)] sm:text-[40px] font-[700] text-gray-700 font-filson-soft">
              {value}
            </span>
          </div>
          <span className="text-[length:min(0.8rem,5vw)] sm:text-[12px] font-[700]">
            {label}
          </span>
        </div>
      </div>
    </div>
  )
}

export default CreditScoreChart
